/** Nome da sala de partida registrada no servidor Colyseus. */
export const MATCH_ROOM = "partida";

/** Fases da sala (ADR 0003 + doc 07, A5). */
export const PHASES = ["lobby", "carregando", "jogando", "fim"] as const;
export type Phase = (typeof PHASES)[number];

/** Código de sala privada: 5 caracteres sem ambíguos (sem 0/O, 1/I/L). */
export const ROOM_CODE_ALPHABET = "23456789ABCDEFGHJKMNPQRSTUVWXYZ";
export const ROOM_CODE_LENGTH = 5;

/** Maiúsculas, sem espaços nem separadores (o código digitado pode vir como "ab-c d3"). */
export function normalizeRoomCode(text: string): string {
  return text.toUpperCase().replace(/[^0-9A-Z]/g, "");
}

export function isRoomCode(text: string): boolean {
  return text.length === ROOM_CODE_LENGTH && [...text].every((c) => ROOM_CODE_ALPHABET.includes(c));
}

/** Tempos do lobby e do carregamento, em segundos. */
export const LOBBY_COUNTDOWN_SECONDS = 5;
export const LOADING_TIMEOUT_SECONDS = 30;
/** Janela de reconexão durante a partida (doc 07, A10). */
export const RECONNECT_SECONDS = 60;

/**
 * Códigos de fechamento próprios. 4000–4999 são da aplicação no WebSocket, mas o Colyseus 0.18 usa
 * 4000–4003 e 4010 (`CloseCode`: consentido, desligamento do servidor, erro, reconexão falhou): os
 * nossos ficam em 41xx (antes da F105 eram 4001–4003 e colidiam; o desligamento aparecia como "o dono
 * removeu você").
 */
export const CLOSE_KICKED = 4101;
/** Não gerou a ilha (ou não confirmou o hash) dentro do prazo de carregamento. */
export const CLOSE_LOAD_TIMEOUT = 4102;
/** Expulso por votação em jogo (doc 07, A11). */
export const CLOSE_VOTE_KICKED = 4103;
/** Removido pela equipe do Eldrun (painel, banimento ou suspensão; F105). */
export const CLOSE_STAFF_KICKED = 4104;
/** O servidor desligando (reinício, publicação): o `CloseCode.SERVER_SHUTDOWN` do Colyseus. */
export const CLOSE_SERVER_SHUTDOWN = 4001;

/**
 * Por que a sala recusou a entrada (F105): o texto vai na mensagem do erro e o jogo mostra como veio.
 * `sessao` e `conta-repetida` são os textos de antes (F32), que o jogo já reconhecia.
 */
export const ENTRY_REFUSALS = {
  sessao: "sessão inválida: entre de novo ou jogue como convidado",
  "conta-repetida": "essa conta já está nesta sala",
  "conta-banida": "Esta conta foi banida.",
  "conta-suspensa": "Esta conta está suspensa. Veja até quando entrando no site.",
  "pre-lancamento": "O Eldrun ainda não abriu: por enquanto só entra quem tem o pré-acesso, com a conta. Entre na lista de espera em eldrun.app.",
  "sem-acesso": "Sua conta ainda não tem o pré-acesso. Ele chega por e-mail para quem está na lista de espera.",
  "expulso-equipe": "A equipe do Eldrun removeu você desta sala.",
  indisponivel: "O servidor de contas não respondeu. Tente de novo em instantes.",
} as const;
export type EntryRefusal = keyof typeof ENTRY_REFUSALS;
